module.exports = __webpack_public_path__ + "media/images/type4-697d7d3c7b296597f2c7d30b840a9ba0.png";